var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 7.842C9.54365 7.22793 8.71059 6.88297 7.84198 6.88297C6.97337 6.88297 6.14031 7.22793 5.52598 7.842L3.20923 10.158C2.59489 10.7723 2.24976 11.6056 2.24976 12.4744C2.24976 13.3432 2.59489 14.1764 3.20923 14.7908C3.82357 15.4051 4.6568 15.7502 5.5256 15.7502C6.39441 15.7502 7.22764 15.4051 7.84198 14.7908L8.99998 13.6328",
    stroke: "#838390",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84198 10.158C8.45631 10.7721 9.28937 11.117 10.158 11.117C11.0266 11.117 11.8596 10.7721 12.474 10.158L14.7907 7.84201C15.4051 7.22767 15.7502 6.39444 15.7502 5.52564C15.7502 4.65683 15.4051 3.8236 14.7907 3.20926C14.1764 2.59492 13.3432 2.24979 12.4744 2.24979C11.6055 2.24979 10.7723 2.59492 10.158 3.20926L8.99998 4.36726",
    stroke: "#838390",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.b23574aaaf5417a6f48634adce655cbe.svg";
export { ForwardRef as ReactComponent };